import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sprout } from "lucide-react";
import { api } from "@/lib/api";

const OFFLINE = new Set(["local-service", "remote-role", "gear-rental"]);
const WORK_ONLINE = "The work includes setting up social media, creating content, and building followers around your niche, and that takes time.";
const WORK_OFFLINE = "The work includes finding your first customers, getting your name out locally and online, and building a good reputation, and that takes time.";

// One-time "plant the bulbs" welcome shown the first time someone opens their matched path.
export const WelcomeCard = ({ opp, hasDoneDays }) => {
  const [data, setData] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/welcome", { params: { opportunity_id: opp.id } }).then(r => r.data.show && setData(r.data)).catch(() => {});
  }, [opp.id]);

  if (!data) return null;
  const name = data.first_name ? `, ${data.first_name}` : "";
  const plant = async () => {
    if (!data.has_path) await api.post("/path/start", { opportunity_id: opp.id }).catch(() => {});
    const msg = hasDoneDays ? `I'm on ${opp.title}. Walk me through my next sprint day.` : `I picked ${opp.title}. Walk me through Day 1 of my 7-day sprint.`;
    nav(`/coach?start=${encodeURIComponent(msg)}`);
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4" data-testid="welcome-card-overlay">
      <div className="card-panel-elevated max-w-lg w-full p-6 sm:p-8 max-h-[90vh] overflow-y-auto" data-testid="welcome-card">
        <Sprout className="text-[#FD0F10]" size={28} />
        <h2 className="mt-3 font-display font-bold text-2xl text-white leading-tight" data-testid="welcome-card-title">Congratulations{name}, you just took the step most people only talk about.</h2>
        <div className="mt-4 space-y-3 text-base text-gray-200 leading-relaxed">
          <p data-testid="welcome-card-truth">Here's the honest truth: {opp.title} is not a get-rich-quick thing. If you're new to online business, digital products or affiliate marketing, there's a learning curve. {OFFLINE.has(opp.id) ? WORK_OFFLINE : WORK_ONLINE}</p>
          <p>Think of it like tulips. If you want tulips next year, you have to plant the bulbs this year. You put the seed in the soil and give it time to grow.</p>
          <p>The people who win here are the ones who keep watering their seeds.</p>
          <p className="text-white font-bold" data-testid="welcome-card-promise">I'll work with you until you make your first dollar online.</p>
        </div>
        <button onClick={plant} className="mt-6 w-full hero-accent text-white font-display font-bold text-lg px-8 py-4 rounded-lg" data-testid="welcome-card-plant-btn">Let's plant it</button>
      </div>
    </div>
  );
};
